import React from 'react';
import classNames from 'classnames';
import Button from '@atlaskit/button/standard-button';
import { LoadingButton, LoadingButtonProps } from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { IconType } from '../icon/src/icons';
import { Icon } from '../icon';
import './warning-dialog.scss';

export const WarningDialog = ({
  isOpen,
  onClose,
  onConfirm,
  header,
  description,
  okLabel,
  testId,
  cancelLabel,
  isLoading,
  isIconRequired = true,
  okLabelAppearance,
  iconType,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  header: string;
  description: React.ReactElement;
  okLabel: string;
  testId?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  isIconRequired?: boolean;
  okLabelAppearance?: LoadingButtonProps['appearance'];
  iconType?: IconType;
}) => {
  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} testId={`warning-modal-dailog-${testId ?? ''}`}>
          <ModalHeader>
            <ModalTitle>
              {isIconRequired && (
                <>
                  <Icon type={iconType ?? 'warning'} />{' '}
                </>
              )}
              <span className={classNames({ 'warning-confirm-header': isIconRequired })}>{header}</span>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>{description}</div>
          </ModalBody>
          <ModalFooter>
            <div id="warning-confirm-footer">
              <Button appearance="subtle" onClick={onClose} className="cancel-button" testId="cancel-warning-dialog">
                {cancelLabel ?? 'Cancel'}
              </Button>
              <LoadingButton
                appearance={okLabelAppearance ?? 'warning'}
                onClick={onConfirm}
                autoFocus
                testId="change-warning-dialog"
                isLoading={isLoading}
              >
                {okLabel}
              </LoadingButton>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default WarningDialog;
